import { Color, TextStyle } from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';

/** Shared by inline editing and automatic-translation HTML conversion. */
export const inlineTranslationExtensions = [
  StarterKit.configure({
    blockquote: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    listKeymap: false,
    codeBlock: false,
    horizontalRule: false,
    trailingNode: false,
    link: { openOnClick: false, autolink: false, linkOnPaste: false },
  }),
  TextStyle,
  Color,
];
